module.exports = __webpack_public_path__ + "img/skull_13_bj.9a41455d.png";